// extracted by mini-css-extract-plugin
export default {"container":"ChangePw_container__ctQvx","changeBox":"ChangePw_changeBox__9MM8d","title":"ChangePw_title__jMCia","input":"ChangePw_input__l30w7","button":"ChangePw_button__kCf96"};